import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import NxtButton from '../components/NxtButton';
import PrevButton from '../components/PrevButton';
import SwitchButton from '../components/SwitchButton';
import { FormStyleButton } from './style';
import ButtonsForm from '../components/buttons/ButtonsForm/ButtonsForm';

const propTypes = {
  previous: PropTypes.string,
  next: PropTypes.string,
  last: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.oneOfType(
    [PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

const defaultProps = {
  previous: '',
  next: '',
  children: [],
  last: '',
  title: '',
  subtitle: null,
  toggleButton: false,
  onClick: null,
  disabled: false,
};

class Form extends React.Component {

  renderFinalizarButton() {
    const { last, onClick, disabled, isExam } = this.props;

    if (last) {
      if (onClick || disabled) {
        return (
          <FormStyleButton>
            <ButtonsForm isAvaliacaoForm={isExam} onClick={() => onClick(last)}/>
          </FormStyleButton>
        )
      }

      return (
        <FormStyleButton>
          <Link to={last} className="sc-AxiKw coUCbo btn mb-3 ml-3 button-terciario">FINALIZAR</Link>
        </FormStyleButton>
      )
    }

    return null;
  }

  render() {
    const {
      title,
      previous,
      next,
      children,
      toggleButton,
      onClick,
      disabled,
      subtitle,
      isExam,
    } = this.props;

    return (
      <div className="card-bg" style={{ width: '100%', height: '100%' }}>
        <div className="card card-form" style={{ width: '100%'}}>
          <div className="card-body" >
            <div className="card-header" style={{ paddingBottom: '0px' }}>
              <div className="row">
                <div className="col-sm-12">
                  <h1 style={{
                    fontFamily: 'Public Sans',
                    fontSize: '18px',
                    fontWeight: 600,
                    lineHeight: '19px',
                    letterSpacing: '0em',
                    textAlign: 'left',
                    color: '#262930'
                  }}
                  >
                    {title}
                  </h1>
                  {subtitle && (
                    <div style={{ marginTop: '8px' }}>
                      <span style={{
                        fontFamily: 'Public Sans',
                        fontSize: '14px',
                        fontWeight: '500',
                        lineHeight: '14px',
                        letterSpacing: '0px',
                        textAlign: 'left',
                        color: '#676A71'
                      }}
                      >
                        {subtitle}
                      </span>
                    </div>
                  )}
                </div>
                <div className="col-sm-3">
                  {toggleButton === true &&
                    <div className="desativar">
                      <p>Desabilitado</p>
                      <SwitchButton />
                    </div>
                  }
                </div>
              </div>
            </div>
            <div className="card-body card-body-form" >{children}
              <div className="row" style={{ width: 'auto' }}>
                <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }} className="col-sm-12 btns-next">
                  <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', height: 'auto', width: 'auto', marginRight: '-18px' }}>
                    {previous ? <PrevButton isExam={isExam} disabled={disabled} to={previous} onClick={onClick ? () => onClick(previous) : null} /> : null}
                    {next ? <NxtButton disabled={disabled} to={next} onClick={onClick ? () => onClick(next) : null} /> : null}
                  </div>
                  <div style={{ marginLeft: '1rem' }}>
                    {this.renderFinalizarButton()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Form.propTypes = propTypes;
Form.defaultProps = defaultProps;

export default Form;
